import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';

@Pipe({
	name: 'filePreview',
	standalone: true,
})
export class FilePreviewPipe implements PipeTransform {
	private readonly sanitizer: DomSanitizer = inject(DomSanitizer);

	transform(file: File): Observable<SafeResourceUrl | null> {
		if (file) {
			const mimeType = file.type;
			if (mimeType.startsWith('image/')) {
				return this.readFileAsDataURL(file);
			}
			if (mimeType === 'application/pdf') {
				const blobUrl = URL.createObjectURL(file);
				return of(this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl));
			}
		}
		return of(this.getIconByUnknownContentType(file.type));
	}

	private readFileAsDataURL(file: File): Observable<SafeResourceUrl | null> {
		if (!file) {
			return of(null);
		}
		return new Observable<SafeResourceUrl | null>((observer) => {
			const reader = new FileReader();
			reader.onload = (): void => {
				const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
				observer.next(safeUrl);
				observer.complete();
			};
			reader.onerror = (): void => {
				observer.next(null);
				observer.complete();
			};
			reader.readAsDataURL(file);
			return () => {
				if (reader.readyState === FileReader.LOADING) {
					reader.abort();
				}
			};
		});
	}

	private getIconByUnknownContentType(contentType: string): SafeResourceUrl {
		let iconPath = 'assets/img/file-icons/';
		if (
			contentType.includes('excel') ||
			contentType.includes('spreadsheet') ||
			contentType.includes('.xls') ||
			contentType.includes('application/vnd.ms-excel') ||
			contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
		) {
			iconPath += 'excel-icon.png';
		} else if (
			contentType.includes('word') ||
			contentType.includes('.doc') ||
			contentType.includes('application/msword') ||
			contentType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
		) {
			iconPath += 'word-icon.png';
		} else if (
			contentType.includes('powerpoint') ||
			contentType.includes('presentation') ||
			contentType.includes('.ppt') ||
			contentType.includes('application/vnd.ms-powerpoint') ||
			contentType.includes('application/vnd.openxmlformats-officedocument.presentationml.presentation')
		) {
			iconPath += 'powerpoint-icon.png';
		} else if (contentType.includes('text')) {
			iconPath += 'text-icon.png';
		} else {
			iconPath += 'unknown-file-icon.png';
		}

		return this.sanitizer.bypassSecurityTrustUrl(iconPath);
	}
}
